export enum ErrorTypes {
  COMMON = "COMMON",
  INFO = "INFO",
  INSUFFICIENT_RESOURCE_CREDITS = "INSUFFICIENT_RESOURCE_CREDITS"
}
